import {SpinnerDefaultBox} from './spinner.default.box';

export const SpinnerBox = SpinnerDefaultBox;